import Vue from 'vue';
import ConfirmForm from '@/components/shared/widgets/ConfirmForm.vue';

export default {
    data() {
        return {
            formEditable: false,
            isFormDirty: false,
            isFormValid: true,
            defaultData: {},
            updatedData: {},
        };
    },
    methods: {
        updateData(data) {
            this.updatedData = data;
        },
        onClickToggle() {
            if (this.isFormDirty && this.formEditable) {
                this.$root.$emit('showModal', {
                    title: this.$t('forms.labels.confirmUnsavedChangesTitle'),
                    component: Vue.component('ConfirmForm', ConfirmForm),
                    payload: { msg: this.$t('msg.confirmUnsavedChanges') },
                    onConfirm: async () => {
                        this.updatedData = this.defaultData;
                        this.formEditable = false;
                        if (this.$refs.mainForm) {
                            this.$refs.mainForm.setFlagsToAllValidationProviders({ dirty: false });
                        }
                    },
                    isForm: false,
                });
            } else {
                this.formEditable = !this.formEditable;
            }
        },
    },
};
